<p-tree
  [value]="nodes"
  [filter]="true"
  filterPlaceholder="Search"
  [scrollHeight]="height"
  [draggableNodes]="editable"
  [droppableNodes]="editable"
  (onNodeDrop)="onNodeDrop()"
  (onNodeExpand)="onNodeExpand($event)"
  (onNodeCollapse)="onNodeCollapse($event)"
>
  <ng-template let-node pTemplate="default">
    <span class="node-content">
      <i *ngIf="editable" class="pi pi-bars drag-handle" aria-hidden="true"></i>
      <span class="node-label">
        {{ node.label }}
      </span>
      <button
        *ngIf="editable"
        pButton
        type="button"
        icon="pi pi-ellipsis-v"
        class="p-button-icon-only p-button-text ellipsis-button"
        (click)="
          $event.stopPropagation(); setActions(node); actionsMenu.toggle($event)
        "
      ></button>
    </span>
  </ng-template>
</p-tree>

<p-menu #actionsMenu appendTo="body" [popup]="true" [model]="actions"></p-menu>

<p-dialog
  [(visible)]="addDialogVisible"
  [header]="addParentPath ? 'Add sub-option?' : 'Add new item?'"
  [dismissableMask]="true"
  [style]="{ width: '50vw' }"
  [breakpoints]="{ '992px': '62vw', '510px': '93vw' }"
  appendTo="body"
  [modal]="true"
  (onHide)="closeAddDialog()"
>
  <ng-container *ngIf="addParentPath">
    <label>Parent</label>
    <br />
    <span class="parent-path">{{ addParentPath }}</span>
    <br />
    <br />
  </ng-container>
  <label>Item</label>
  <br />
  <input
    [(ngModel)]="newItemName"
    type="text"
    placeholder="Enter new item"
    autofocus
    pInputText
  />
  <p-message
    *ngIf="addError"
    severity="error"
    [text]="addError"
    styleClass="p-mt-2"
  >
  </p-message>
  <ng-template pTemplate="footer">
    <button
      pButton
      label="Cancel"
      icon="pi pi-times"
      (click)="closeAddDialog()"
    ></button>
    <button
      pButton
      label="Add"
      icon="pi pi-plus"
      (click)="addItem()"
      class="p-button-success"
    ></button>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="editDialogVisible"
  header="Rename item?"
  [dismissableMask]="true"
  [style]="{ width: '50vw' }"
  [breakpoints]="{ '992px': '62vw', '510px': '93vw' }"
  appendTo="body"
  [modal]="true"
  (onHide)="closeEditDialog()"
>
  <label>Item</label>
  <br />
  <input
    *ngIf="activeNode"
    pInputText
    [(ngModel)]="renameValue"
    type="text"
    placeholder="Enter new name"
    autofocus
  />
  <br />
  <p-message
    *ngIf="activeSubtreePaths.length > 1"
    severity="warn"
    [text]="
      'This will also update ' +
      (activeSubtreePaths.length - 1) +
      ' sub-option(s)'
    "
    styleClass="p-mt-2"
  >
  </p-message>
  <p-message
    *ngIf="editWarning"
    severity="warn"
    [text]="editWarning"
    styleClass="p-mt-2"
  >
  </p-message>
  <p-message
    *ngIf="renameError"
    severity="error"
    [text]="renameError"
    styleClass="p-mt-2"
  >
  </p-message>
  <ng-template pTemplate="footer">
    <button
      pButton
      label="Cancel"
      icon="pi pi-times"
      (click)="closeEditDialog()"
    ></button>
    <button
      pButton
      label="Rename"
      icon="pi pi-check"
      class="p-button-success"
      (click)="renameItem()"
    ></button>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="deleteDialogVisible"
  header="Delete {{ activeSubtreePaths.length }} item(s)?"
  [dismissableMask]="true"
  [style]="{ width: '50vw' }"
  [breakpoints]="{ '992px': '62vw', '510px': '93vw' }"
  appendTo="body"
  [modal]="true"
  (onHide)="closeDeleteDialog()"
>
  <ng-template pTemplate="content">
    This will delete the following items:
    <ul>
      <li *ngFor="let path of activeSubtreePaths" class="items-to-delete">
        <span class="error-text">{{ path }}</span>
      </li>
    </ul>
    <p-message *ngIf="deleteWarning" severity="warn" [text]="deleteWarning">
    </p-message>
  </ng-template>
  <ng-template pTemplate="footer">
    <button
      pButton
      label="No, Exit Window"
      icon="pi pi-times"
      (click)="closeDeleteDialog()"
    ></button>
    <button
      pButton
      label="Delete"
      class="p-button-danger"
      icon="pi pi-trash"
      (click)="deleteItem()"
    ></button>
  </ng-template>
</p-dialog>
